(function () {
  if (!('ontouchstart' in window)) return;

  // Disable magnify.js click zoom on touch devices — override global so product-info.js
  // re-calls also become no-ops, then null out any onclick already set.
  window.enableZoomOnHover = function () {};

  function nullMagnifyOnclicks() {
    document.querySelectorAll('.image-magnify-hover').forEach(function (img) {
      img.onclick = null;
    });
  }

  function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
  }

  function initPinchZoom(container) {
    var img = container.querySelector('img');
    if (!img || container._pinchZoomInit) return;
    container._pinchZoomInit = true;

    var scale = 1;
    var baseScale = 1;
    var tx = 0, ty = 0;
    var baseTx = 0, baseTy = 0;
    var initDist = 0;
    var panStartX = 0, panStartY = 0;
    var pinching = false;
    var panning = false;

    function dist(t1, t2) {
      var dx = t1.clientX - t2.clientX;
      var dy = t1.clientY - t2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function apply(animated) {
      img.style.transition = animated ? 'transform 0.25s ease' : 'none';
      img.style.transformOrigin = 'center center';
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    }

    function reset() {
      scale = 1; tx = 0; ty = 0; baseTx = 0; baseTy = 0;
      apply(true);
    }

    function clampPan() {
      var maxX = (container.offsetWidth  * (scale - 1)) / 2;
      var maxY = (container.offsetHeight * (scale - 1)) / 2;
      tx = clamp(tx, -maxX, maxX);
      ty = clamp(ty, -maxY, maxY);
    }

    container.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pinching = true;
        panning  = false;
        initDist  = dist(e.touches[0], e.touches[1]);
        baseScale = scale;
        baseTx = tx; baseTy = ty;
        e.preventDefault();
      } else if (e.touches.length === 1 && scale > 1.05) {
        panning  = true;
        pinching = false;
        panStartX = e.touches[0].clientX - tx;
        panStartY = e.touches[0].clientY - ty;
        e.preventDefault();
      }
    }, { passive: false });

    container.addEventListener('touchmove', function (e) {
      if (pinching && e.touches.length === 2) {
        var d = dist(e.touches[0], e.touches[1]);
        scale = clamp(baseScale * (d / initDist), 1, 4);
        clampPan();
        apply(false);
        e.preventDefault();
      } else if (panning && e.touches.length === 1 && scale > 1.05) {
        tx = e.touches[0].clientX - panStartX;
        ty = e.touches[0].clientY - panStartY;
        clampPan();
        apply(false);
        e.preventDefault();
      }
    }, { passive: false });

    container.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) pinching = false;
      if (e.touches.length === 0) {
        panning = false;
        if (scale < 1.05) reset();
      }
    });
  }

  function injectStyles() {
    var s = document.createElement('style');
    s.textContent = [
      '@keyframes ptz-in{from{opacity:0;transform:translate(-50%,-50%) scale(.85)}to{opacity:1;transform:translate(-50%,-50%) scale(1)}}',
      '@keyframes ptz-out{from{opacity:1}to{opacity:0}}',
      '.ptz-hint{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);',
      'background:rgba(0,0,0,.52);color:#fff;border-radius:2rem;',
      'padding:.8rem 1.6rem;display:flex;align-items:center;gap:.6rem;',
      'font-size:1rem;font-family:sans-serif;letter-spacing:.02em;',
      'pointer-events:none;z-index:10;white-space:nowrap;',
      'animation:ptz-in .2s ease forwards;}',
      '.ptz-hint.ptz-fade{animation:ptz-out .4s ease forwards;}',
      '.ptz-hint svg{width:1.4em;height:1.4em;flex-shrink:0;}'
    ].join('');
    document.head.appendChild(s);
  }

  function showPinchHint(wrapper) {
    var hint = document.createElement('div');
    hint.className = 'ptz-hint';
    hint.innerHTML = '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
      + '<circle cx="10" cy="22" r="2"/>'
      + '<circle cx="22" cy="10" r="2"/>'
      + '<line x1="11.4" y1="20.6" x2="20.6" y2="11.4"/>'
      + '<polyline points="17,10 22,10 22,15"/>'
      + '<polyline points="10,17 10,22 15,22"/>'
      + '</svg>'
      + '<span>Pinch to zoom</span>';
    wrapper.style.position = 'relative';
    wrapper.appendChild(hint);
    setTimeout(function () { hint.classList.add('ptz-fade'); }, 900);
    setTimeout(function () { hint.remove(); }, 1350);
  }

  function setup() {
    injectStyles();
    nullMagnifyOnclicks();
    var hintShown = false;
    document.querySelectorAll('.product__media').forEach(function (el) {
      el.style.overflow = 'hidden';
      initPinchZoom(el);
    });
    // Show hint on first visible product image — attach to product-media-container
    // (parent of product__media) which has no overflow:hidden
    var firstMedia = document.querySelector('.product-media-container .product__media');
    if (firstMedia) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !hintShown) {
            hintShown = true;
            var wrapper = entry.target.closest('.product-media-container') || entry.target.parentElement;
            showPinchHint(wrapper);
            obs.disconnect();
          }
        });
      }, { threshold: 0.5 });
      observer.observe(firstMedia);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
